import { buildHttpClient } from './httpClient';
import { useClient } from './useClient';
import { useLoader } from './useLoader';

const api = { buildHttpClient, useClient, useLoader };

export default api;
